export { BANKSLIP_PAYMENT_PT_BR } from "./bankslip-payment-pt-br";
export { BANKSLIP_PAYMENT_EN_US } from "./bankslip-payment-en-us";
export { BANKSLIP_PAYMENT_ES_MX } from "./bankslip-payment-es-mx";
export { BANKSLIP_PAYMENT_FR_FR } from "./bankslip-payment-fr-fr";
